module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#trending",
      toString: function () {
        return this.url;
      }
    }